import React, { useRef, useEffect } from 'react';
import { TOOLTIPS } from '../../constants/constants';
const QuickTips = (props) => {

    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            props.setShowToolTip(false);
            if(event.target.textContent == 'Quick Tips'){
                props.setShowToolTip(true); //show tooltip again if clicked on quick tips
            }
          }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
          document.removeEventListener('click', handleClickOutside, true);
        };
    });

    return (<div className="tips-wrap" ref={ref}>
        <div className="close-wrap"
            onClick={() => {
                props.setShowToolTip(false);
            }}>
            <span className="close">
                <i className="icon-cross-icon"></i>
            </span>
        </div>
        <div className="tips" dangerouslySetInnerHTML={{ __html: TOOLTIPS[props.section] }}>
        </div>
    </div>);
}

export default QuickTips;